<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <div class="content">
                <!-- 文本 -->
                <div class="date-box">
                    请选择日期
                    <img src="@/images/icon/date@3x.png" />
                </div>
            </div>
            <!-- 底部操作栏 -->
            <div class="footer-operation" v-if="footerShow">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                ></action-bar>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-date">
// js
import { ref, watch, provide } from "vue";

// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
// 复制题目，删除题目, 数据改变, 单题预览;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);
const titileInput = ref(null);

watch(
    () => props.dataList,
    (curr, old) => {
        emits("change", curr);
    },
    { deep: true }
);

provide("data", props.dataList);
defineExpose({ titileInput });
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

.question-item {
    .question-item-content {
        .date-box {
            width: 285px;
            height: 30px;
            line-height: 30px;
            border-radius: 4px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(229, 232, 238, 1);
            font-size: 14px;
            font-weight: 400;
            color: rgba(112, 120, 134, 1);
            padding-left: 10px;
            position: relative;
            img {
                width: 18px;
                height: 18px;
                position: absolute;
                right: 11px;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
}
</style>
